import { Map } from 'immutable'

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export function selectAuth (state) {
  return state.auth || Map()
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectAuthorized (state) {
  return !!state.auth.get('jwt', '')
}

/**
 * @param {ReduxState} state redux state
 * @returns {String}
 */
export function selectUsername (state) {
  return state.auth.get('username', '')
}
